import axios from "axios";
import { showScreenLoading, hideScreenLoading } from "../../utils/loading";
import { baseUrl } from "../url";
import Compressor from 'compressorjs';
const instance = axios.create({
  timeout: 30000,
  baseURL: "https://img.eqlee.com/v1",
  headers: {
    "Content-Type": "application/json",
  },
});
// 请求拦截
instance.interceptors.request.use((config) => {
  if (config.url !== "/AccessToken") {
    if (config.headers.showLoading !== false) {
      if (config.data && config.data.loading == false) {
      }
      else if (config.params && config.params.loading == false) {
      } else {
        showScreenLoading(config.headers);

      }
    }
    return refreshToken()
      .then((res) => {
        config.headers.Authorization = setToken();
        return config;
      })
      .catch(() => {
        config.headers.Authorization = setToken();
        return config;
      });
  } else {
    return config;
  }
}), error => {
  if (config.headers.showLoading !== false) {
    hideScreenLoading(config.headers);
  }
  this.$message.error("请求超时!");
  return Promise.reject(error);
};

// 响应拦截
instance.interceptors.response.use(
  (response) => {
    console.log(response);
    setTimeout(() => {
      if (response.config.headers.showLoading !== false) {
        hideScreenLoading();
      }
    }, 100);
    return response.data;
  },
  (error) => {
    setTimeout(() => {
      if (response.config.headers.showLoading !== false) {
        hideScreenLoading();
      }
    }, 100);
    const status = error.response?.status
    console.log(error);
    // const status = error.response.status;
    return Promise.reject(error);
  }
);
function setToken() {
  const tokenType = JSON.parse(localStorage.getItem("AccessToken")).tokenType;
  const token = JSON.parse(localStorage.getItem("AccessToken")).token;
  return `${tokenType} ${token}`;
}
function isExpired() {
  const time =
    (localStorage.getItem("AccessToken") &&
      JSON.parse(localStorage.getItem("AccessToken")).expiresAt) ||
    0;
  if (!time) return true;

  var date = new Date();
  var y = date.getUTCFullYear();
  var m = date.getUTCMonth();
  var d = date.getUTCDate();
  var h = date.getUTCHours();
  var M = date.getUTCMinutes();
  var s = date.getUTCSeconds();
  var ms = date.getUTCMilliseconds();
  var utcTimestamp = Date.UTC(y, m, d, h, M, s, ms);
  if (utcTimestamp >= time - 30000) {
    return true;
  } else {
    return false;
  }
}
function refreshToken() {
  return new Promise((resolve, reject) => {
    if (!localStorage.getItem("AccessToken") || isExpired()) {
      getUploadToken().then((res) => {
        resolve(res);
      });
    } else {
      reject("had AccessToken");
    }
  });
}
function getUploadToken() {
  return new Promise((resolve, reject) => {
    instance({
      method: "post",
      url: `/AccessToken`,
      data: {
        accessKey: baseUrl.uploadKey,
        accessKeySecret: baseUrl.uploadSecret,
      },
    }).then((res) => {
      if (res.code === 0) {
        localStorage.setItem("AccessToken", JSON.stringify(res.data));
        resolve(res.data);
      } else {
        reject("err");
      }
    });
  });
}

const upload = {
  // 上传文件
  uploadFile(data) {
    return instance({
      method: "post",
      url: `/Upload`,
      data,
    });
  },

  // 上传单张图片
  uploadSingleImage(file) {
    console.log(file.type);
    if (file.type.indexOf('jpeg') != -1 || file.type.indexOf('png') != -1 || file.type.indexOf('jpeg') != -1 || file.type.indexOf('jpg') != -1) {
      console.log(1);
      return new Promise((resolve, reject) => {
        let data = new FormData();
        new Compressor(file, {
          quality: 0.4,
          success(result) {
            // console.log(result);
            let file = new File([result], result.name, { type: result.type })
            console.log(file);
            data.append("file", file);
            instance({
              method: "post",
              url: `/UploadImage/Single`,
              data,
            }).then((res) => {
              resolve(res);
            }).catch((err) => {
              reject(err)
            });
          },
          error(err) {
            console.log(err.message);
          },
        });
      })
    } else {
      const data = new FormData();
      data.append("file", file);
      return instance({
        method: "post",
        url: `/UploadImage/Single`,
        data,
      });
    }
  },

  // 上传多张图片
  uploadMutipleImage(data) {
    return instance({
      method: "post",
      url: `/UploadImage/Mutiple`,
      data,
    });
  },
};

export default upload;
